export enum ButtonMargin {
    NONE = "0",
    SHORT = "4px",
    MEDIUM = "8px",
    WIDE = "16px",
    EXTRA_WIDE = "32px",
}